"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUvBestaendigkeit = exports.UvBestaendigkeit = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * Defines the resistance vs UV beams.
 */
var UvBestaendigkeit;
(function (UvBestaendigkeit) {
    UvBestaendigkeit["Keine"] = "Keine";
    UvBestaendigkeit["Gering"] = "Gering";
    UvBestaendigkeit["Mittel"] = "Mittel";
    UvBestaendigkeit["Hoch"] = "Hoch";
})(UvBestaendigkeit = exports.UvBestaendigkeit || (exports.UvBestaendigkeit = {}));
const isUvBestaendigkeit = (u) => {
    return (0, echain_shared_ts_utils_1.isValueInEnum)(UvBestaendigkeit, u);
};
exports.isUvBestaendigkeit = isUvBestaendigkeit;
//# sourceMappingURL=UvBestaendigkeit.js.map